<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('close')" />
    <div class="modal">
      <div class="modal-content">
        <div v-if="invite.organization.logo" class="org-image-wrapper">
          <div class="org-image" :style="{ backgroundImage: `url(${invite.organization.logo})` }" />
        </div>
        <div class="invite-text">
          <p class="invite-title">
            {{ adminText('organizationAll.you_are_invited_to_be_a76853a6', 'You are invited to be') }} {{ organizationText(roleName) }} {{ adminText('organizationAll.in_af10ef20', 'in') }}
            {{ invite.organization.publicName }} {{ adminText('organizationAll.organization_at_coreevent_22e123fc', 'organization at CoreEvent.') }}
          </p>
          <p class="invite-description">
            {{ organizationText(roleDescription) }}
          </p>
        </div>
      </div>
      <div class="modal-footer">
        <button class="reject-button" :disabled="loading" @click="$emit('reject')">{{ adminText('organizationAll.reject_40c5a5de', 'REJECT') }}</button>
        <main-button :loading="loading" depressed @click="$emit('accept')"> {{ adminText('organizationAll.accept_514158e8', 'ACCEPT') }} </main-button>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

const ROLE_LABELS = {
  OWNER: 'Owner',
  ADMIN: 'Administrator',
  EVENT_ADMIN: 'Event Administrator',
  EVENT_VIEWER: 'Event Viewer',
}

const ROLE_DESCRIPTIONS = {
  OWNER:
    'As an organization owner, you will have full control over all events, users, and organization settings.',
  ADMIN:
    'As an organization administrator, you will be able to manage events, users, and organization settings with nearly the same permissions as the owner.',
  EVENT_ADMIN:
    'As an event administrator, you will be able to edit all event details, manage participants, and analyze data.',
  EVENT_VIEWER:
    'As an event viewer, you will have access to statistics and reports, but you will not be able to modify settings.',
}

export default {
  mixins: [OrganizationLocalization],
  name: 'organization-invite-modal',
  props: {
    invite: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    roleName() {
      return ROLE_LABELS[this.invite.organizationRole] || this.invite.organizationRole
    },
    roleDescription() {
      return (
        ROLE_DESCRIPTIONS[this.invite.organizationRole] ||
        'You will have access to the organization.'
      )
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}

.modal {
  background-color: white;
  position: relative;
  width: 100%;
  max-width: 480px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0px 4px 16px 0px rgba(51, 51, 51, 0.16);
}

.modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 32px 24px 16px;
}

.org-image-wrapper {
  width: 148px;
  height: 148px;
}

.org-image {
  width: 144px;
  height: 144px;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  background-color: #f5f5f5;
  border: 2px solid #d9d9d9;
}

.invite-text {
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: center;
  color: #666;
  width: 100%;
}

.invite-title {
  font-family: 'Raleway', sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 1.2;
  letter-spacing: -0.72px;
  font-feature-settings: 'pnum' on, 'lnum' on;
  margin: 0;
}

.invite-description {
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
}

.reject-button {
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.2;
  letter-spacing: -0.27px;
  text-transform: uppercase;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #db384c;
  background: white;
  border: none;
  cursor: pointer;
  padding: 12px 24px;
  border-radius: 24px;
}

.reject-button:hover {
  background-color: #fef2f3;
}

.reject-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media screen and (max-width: 520px) {
  .modal {
    max-width: 100%;
    margin: 0 16px;
  }

  .invite-title {
    font-size: 20px;
  }
}
</style>
